export default __webpack_public_path__ + "static/media/pool-recommendation.dbf84142.svg";